import { ChildProfileDTO } from './child-profile.dto';
import { ChildProfile } from './child-profile.entity';

export class ChildProfileMapper {
  static toEntity(dto: ChildProfileDTO): ChildProfile {
    return {
      id: dto.id,
      fullName: dto.fullName,
      gender: dto.gender,
      school: dto.school || undefined,
      avatarId: dto.avatarId,
      avatar: {
        id: dto.avatar.id,
        name: dto.avatar.name,
        urlPath: dto.avatar.urlPath,
      },
      level: {
        id: dto.level.id,
        name: dto.level.name,
        index: dto.level.index,
      },
      subscription: dto.subscription
        ? {
            isActive: dto.subscription.isActive,
            activePack: dto.subscription.ActivePack
              ? {
                  id: dto.subscription.ActivePack.id,
                  name: dto.subscription.ActivePack.name,
                }
              : undefined,
          }
        : undefined,
      achievement: dto.achievement
        ? {
            id: dto.achievement.id,
            stars: dto.achievement.stars,
            totalStars: dto.achievement.totalStars,
            totalExercises: dto.achievement.totalExercises,
            finishedChapters: dto.achievement.finishedChapters,
            totalLevelExercises: dto.achievement.totalLevelExercises,
          }
        : undefined,
      lastLoginAt: dto.lastLoginAt || undefined,
    };
  }
}
